// Lịch sale trong tháng (theo giờ máy khách — khách VN). Qua đợt nào → tự lấy đợt kế tiếp.

// Thứ tự = ưu tiên khi 2 đợt trùng ngày (1.1: "ngày đôi" thắng "đầu tháng").
export const PROMO_TYPES = [
  {
    key: "ngay-doi",
    name: "Sale ngày đôi",
    hint: "Ngày = tháng: 1.1, 2.2 … 12.12",
    day: (month) => month,
    title: "SIÊU SALE {ngày}",
    description: "Mua càng nhiều – tiết kiệm càng lớn",
  },
  {
    key: "dau-thang",
    name: "Sale đầu tháng",
    hint: "Ngày 1 hằng tháng",
    day: () => 1,
    title: "SALE ĐẦU THÁNG {tháng}",
    description: "Mở màn tháng mới – ưu đãi ngập tràn",
  },
  {
    key: "giua-thang",
    name: "Sale giữa tháng",
    hint: "Ngày 15 hằng tháng",
    day: () => 15,
    title: "SALE GIỮA THÁNG {ngày}",
    description: "Deal hời giữa tháng – số lượng có hạn",
  },
  {
    key: "luong-ve",
    name: "Sale lương về",
    hint: "Ngày 25 hằng tháng",
    day: () => 25,
    title: "SALE LƯƠNG VỀ {ngày}",
    description: "Lương về – chăm sức khỏe cả nhà",
  },
];

export const DEFAULT_PROMO = {
  mode: "auto",
  cta: "Mua ngay",
  link: "/flash-sale",
  events: PROMO_TYPES.map(({ key, title, description }) => ({ key, enabled: true, title, description })),
};

/** Gộp cấu hình đã lưu với mặc định theo từng loại đợt (thiếu trường nào lấy mặc định). */
export const resolveEvents = (saved) =>
  PROMO_TYPES.map((t) => {
    const s = (Array.isArray(saved) ? saved : []).find((e) => e?.key === t.key) || {};
    return {
      ...t,
      enabled: s.enabled !== false,
      title: s.title || t.title,
      description: s.description ?? t.description,
    };
  });

/**
 * Đợt sale đang diễn ra hoặc gần nhất sắp tới.
 * @returns {{ key, name, label, day, month, start, end, live, title, description } | null}
 *  label "11.11" / "15.11"; start/end = 00:00 ngày sale / 00:00 hôm sau.
 *  null nếu tắt hết các đợt.
 */
export const getPromoEvent = (now = new Date(), savedEvents) => {
  const types = resolveEvents(savedEvents).filter((t) => t.enabled);
  if (!types.length) return null;
  // Xét tháng này + tháng sau là đủ (mỗi tháng có ít nhất 1 đợt nếu còn loại nào bật)
  for (let offset = 0; offset < 3; offset++) {
    const base = new Date(now.getFullYear(), now.getMonth() + offset, 1);
    const year = base.getFullYear();
    const month = base.getMonth() + 1;
    const byDay = new Map(); // gộp đợt trùng ngày theo thứ tự ưu tiên
    types.forEach((t) => {
      const day = t.day(month);
      if (!byDay.has(day)) byDay.set(day, t);
    });
    const candidates = [...byDay.entries()]
      .map(([day, t]) => ({ t, day, start: new Date(year, month - 1, day), end: new Date(year, month - 1, day + 1) }))
      .filter((c) => c.end > now)
      .sort((a, b) => a.start - b.start);
    if (candidates.length) {
      const { t, day, start, end } = candidates[0];
      return {
        key: t.key,
        name: t.name,
        title: t.title,
        description: t.description,
        label: `${day}.${month}`,
        day,
        month,
        start,
        end,
        live: now >= start && now < end,
      };
    }
  }
  return null;
};

const VAR_RE = /\{(ng[aà]y|th[aá]ng)\}/gi;
const varValue = (name, ev) => (/^ng/i.test(name) ? ev.label : String(ev.month));

/** Thay biến: {ngày}/{ngay} → "15.11", {tháng}/{thang} → "11". */
export const fillPromoText = (text, ev) => String(text || "").replace(VAR_RE, (_, n) => varValue(n, ev));

/** Như fillPromoText nhưng trả về các đoạn, đánh dấu đoạn là biến để tô màu nổi bật. */
export const fillPromoParts = (text, ev) => {
  const parts = [];
  let last = 0;
  String(text || "").replace(VAR_RE, (m, n, idx) => {
    if (idx > last) parts.push({ text: text.slice(last, idx), hl: false });
    parts.push({ text: varValue(n, ev), hl: true });
    last = idx + m.length;
    return m;
  });
  if (last < String(text || "").length) parts.push({ text: String(text).slice(last), hl: false });
  return parts;
};

/** Số ngày còn lại (làm tròn lên) tới lúc bắt đầu. */
export const daysUntil = (date, now = new Date()) => Math.ceil((date - now) / 86400000);
